export interface IDropDownItem {
  label: string;
  value: string;
}
